import { render, staticRenderFns } from "./CustomCarouselItem3.vue?vue&type=template&id=70c88862"
import script from "./CustomCarouselItem3.vue?vue&type=script&lang=js"
export * from "./CustomCarouselItem3.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports